import { useContext } from 'react';
import HeaderContext from '../contexts/Header/HeaderContext';

export default () => {
    const { state, actions } = useContext(HeaderContext);
    return [state, actions];
};
